export default __webpack_public_path__ + "static/media/colgantes.b63a9600.svg";